import { useCallback, useEffect, useState } from 'react';

export function useAiSearch() {
  const [enabled, setEnabledLocal] = useState<boolean>(() => {
    if (typeof window === 'undefined') return true;
    const p = new URLSearchParams(window.location.search).get('ai_search');
    return p === null ? true : p !== 'false';
  });

  useEffect(() => {
    const onChange = (e?: Event) => {
      if (
        e &&
        (e as CustomEvent).detail &&
        typeof (e as CustomEvent).detail.enabled === 'boolean'
      ) {
        setEnabledLocal((e as CustomEvent).detail.enabled);
        return;
      }
      const p = new URLSearchParams(window.location.search).get('ai_search');
      setEnabledLocal(p === null ? true : p !== 'false');
    };

    window.addEventListener('ai-search-change', onChange as EventListener);
    window.addEventListener('popstate', onChange as EventListener);
    return () => {
      window.removeEventListener('ai-search-change', onChange as EventListener);
      window.removeEventListener('popstate', onChange as EventListener);
    };
  }, []);

  const setEnabled = useCallback((next: boolean) => {
    setEnabledLocal(next);
    if (typeof window === 'undefined') return;
    try {
      const url = new URL(window.location.href);
      if (next === false) url.searchParams.set('ai_search', 'false');
      else url.searchParams.delete('ai_search');
      window.history.replaceState({}, '', url.toString());
      window.dispatchEvent(
        new CustomEvent('ai-search-change', { detail: { enabled: next } })
      );
    } catch {
      // ignore
    }
  }, []);

  return { enabled, setEnabled };
}
export default useAiSearch;
